<template>
  <v-app class="view">
    <v-dialog
        v-model="EditObjectDialog"
        max-width="600"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedObject" @submit.prevent="onSubmitObject">
        <v-card class="pa-8">
          <v-container>
            <v-row>
              <v-col>
                <v-text-field

                    v-model="selectedObject.name"
                    class="dialog-input"
                    label="ชื่อแคมเปญ"
                    outlined
                    placeholder=""
                    required
                >
                </v-text-field>

              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field

                    v-model="new Date(selectedObject.datetime_start).toLocaleDateString('th-TH')"
                    class="dialog-input"
                    label="เริ่ม"
                    outlined
                    placeholder=""
                    required
                    readonly
                    @click="$root.$emit('openDatePicker',{date:selectedObject.datetime_start,onApply:date=>selectedObject.datetime_start=date})"
                >
                </v-text-field>
                <v-select
                    v-model="selectedObject.price_group"
                    :items="price_group_selector"
                    label="กลุ่มราคา"
                    outlined
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                    v-model="new Date(selectedObject.datetime_end).toLocaleDateString('th-TH')"
                    class="dialog-input"
                    label="สิ้นสุด"
                    outlined
                    placeholder=""
                    required
                    readonly
                    @click="$root.$emit('openDatePicker',{date:selectedObject.datetime_end,onApply:date=>selectedObject.datetime_end=date})"
                ></v-text-field>


              </v-col>
            </v-row>
          </v-container>


          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn class="float-left mt-4 ml-12" color="" plain small text @click="deletingObject()">
            <v-icon x-small>mdi-delete</v-icon>
            ลบแคมเปญ
          </v-btn>
          <v-btn :loading="objectLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-checkbox
              v-model="selectedObject.enabled"
              class="dialog-input  float-right mr-8"
              label="ใช้งาน"
              outlined
          >
          </v-checkbox>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>


    <v-navigation-drawer
        :width="drawer_width"
        absolute
        class="nav fix-menu"
        permanent
        touchless
    >
      <v-card :class="{primary:price_group===1}" class="pa-2" outlined tile @click="loadPriceGroup(1)">
        ออนไลน์
      </v-card>
      <v-card :class="{primary:price_group===2}" class="pa-2" outlined tile @click="loadPriceGroup(2)">
        หน้าร้าน/เพจ
      </v-card>
      <v-card :class="{primary:price_group===3}" class="pa-2" outlined tile @click="loadPriceGroup(3)">
        โปรฯอีสาน
      </v-card>
      <v-card :class="{primary:price_group===4}" class="pa-2" outlined tile @click="loadPriceGroup(4)">
        โปรฯหลงจง
      </v-card>
      <v-card :class="{primary:price_group===5}" class="pa-2" outlined tile @click="loadPriceGroup(5)">
        โปรฯ TT
      </v-card>
      <v-card :class="{primary:price_group===6}" class="pa-2" outlined tile @click="loadPriceGroup(6)">
        โปรฯ PJ
      </v-card>
      <v-card :class="{primary:price_group===7}" class="pa-2" outlined tile @click="loadPriceGroup(7)">
        โปรฯ PJ เอกชน
      </v-card>


    </v-navigation-drawer>
    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>
        <v-card>
          <v-card-title>
            จัดการแคมเปญ
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="ค้นหา"
                single-line
            ></v-text-field>
          </v-card-title>
          <v-data-table
              v-if="objects && Array.isArray(objects)"
              :headers="[
                        { text: 'รายการ', value: 'name' },
                        { text: 'วันที่', value: 'datetime_start'},
                        { text: 'สถานะ', value: 'status' , width: '120px', fixed: true },
                        { text: 'แก้ไข', value: 'edit', width: '250px', fixed: true },
                      ]"
              :items="objects"
              :loading="objectsLoading"

              :search="search"
              class="elevation-1 mb-12 tr-clickable"
              @click:row="viewObject"
          >
            <template v-slot:item.edit="{ item }">
              <v-btn class="primary" outlined small @click.stop="editObject(item)">แก้ไข</v-btn>
              <v-btn class="primary ml-2" outlined small @click.stop="viewObject(item)">แสดง โปรฯ</v-btn>
            </template>
            <template v-slot:item.datetime_start="{ item }">
              {{ $helper.date_format_short(item.datetime_start) }} -
              {{ $helper.date_format_short(item.datetime_end) }}
            </template>
            <template v-slot:item.enabled="{ item }">
              {{ item.enabled ? 'เปิดใช้งาน' : 'ปิด' }}
            </template>

            <template v-slot:item.status="{ item }" >
            <span :class="{enabled:item.status==='ใช้งานอยู่',disabled:item.status==='หมดอายุ',}"> {{ item.status}}</span>
            </template>

          </v-data-table>
          <v-btn absolute

                 bottom
                 class="close-button float-left"
                 color="primary"
                 fab
                 left @click="newObject">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card>


      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>
.enabled {
  color: green;
}
.disabled {
  color: darkred;
}


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.theme--light .primary {
  color: #FFFFFF !important;
}



</style>
<script lang="ts">

import {Campaign} from '@/models/Campaign'
import {SimpleResponse} from '@/models/Model'
import {DataArray} from '@/models/Response'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import router from '../router'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy},
})
export default class ViewAdminCampaign extends Vue {

  search = ''

  price_group = 1

  drawer_ratio = 0.15
  drawer_width = 200

  show_password = false

  objects: Campaign[] = []

  objectLoading = false
  objectsLoading = false
  EditObjectDialog = false
  selectedObject: Campaign | null = null

  price_group_selector = [
    {text: 'ออนไลน์', value: 1},
    {text: 'หน้าร้าน/เพจ', value: 2},
    {text: 'โปรฯอีสาน', value: 3},
    {text: 'โปรฯหลงจง', value: 4},
    {text: 'โปรฯ TT', value: 5},
    {text: 'โปรฯ PJ', value: 6},
    {text: 'โปรฯ PJ เอกชน', value: 7},
  ]

  async viewObject(object: Campaign) {
    router.push('/campaign/' + object.id + '/promotions').then(() => {
    })
  }

  async editObject(object: Campaign) {
    this.objectLoading = true

    this.EditObjectDialog = true

    if (object.id) {
      this.selectedObject = await (new Campaign()).load<Campaign>(object.id)
    }

    this.objectLoading = false

  }

  newObject() {
    this.selectedObject = new Campaign()
    this.selectedObject.price_group = this.price_group
    this.selectedObject.datetime_start = '2021-01-01'
    this.selectedObject.datetime_end = '2021-12-31'
    this.selectedObject.enabled = true
    this.EditObjectDialog = true

  }

  cancel() {

    this.EditObjectDialog = false
  }

  async onSubmitObject() {
    this.objectLoading = true
    const isNew = this.selectedObject?.id === null

    this.selectedObject = Object.setPrototypeOf(this.selectedObject, Campaign.prototype)

    if (this.selectedObject) {
      try{
        let object = await this.selectedObject.save<Campaign>()

        this.objectLoading = false

        if (isNew) {
          this.objects.push(object)
        } else {
          for (let i in this.objects) {
            if (this.objects[i].id == object.id) {
              this.objects[i] = object
            }
          }
        }
      }catch (e){
        this.$root.$emit('onError', {error: e})
      }
    }
    this.selectedObject = null
    this.EditObjectDialog = false
  }

  async deletingObject() {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject()
      }
    })

  }

  async deleteObject() {
    try {
      if (this.selectedObject == null) return
      this.objectLoading = true

      this.selectedObject = Object.setPrototypeOf(this.selectedObject, Campaign.prototype)

      const response: SimpleResponse = await this.selectedObject?.delete()

      this.objects = this.objects.filter(object => object.id != this.selectedObject?.id)

      this.selectedObject = null
      this.EditObjectDialog = false

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }
    this.objectLoading = false
  }

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)

    if (this.$route.params.price_group) {
      this.price_group = parseInt(this.$route.params.price_group)
    }

    this.refreshCampaign().then(() => {
    })
  }

  async loadPriceGroup(price_group) {
    this.price_group = price_group
    await this.refreshCampaign()
  }

  async refreshCampaign() {
    const url = Helper.setting.campaign.getListAdminAPI + '?price_group=' + this.price_group

    try {
      this.objectsLoading = true
      this.objects = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
    } catch (e) {
      alert(e)
    }
    this.objectsLoading = false
  }

}
</script>
